import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to the top on every navigation. Keyed on location.key rather than
// pathname so clicking a link to the page you are already on also resets
// the scroll position (each Link click pushes a new history entry).
// Links with a hash (/#how) scroll to that section instead.
function ScrollToTop() {
  const { key, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      return undefined;
    }
    // The target section may not be rendered yet on a fresh page load.
    const frame = requestAnimationFrame(() => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return () => cancelAnimationFrame(frame);
  }, [key, hash]);

  return null;
}

export default ScrollToTop;
